import { css, html, LitElement } from 'lit-element';
import '@vaadin/vaadin-accordion';
import '../ki-station-list/ki-station-list';
import '../ki-station-list/ki-station-list-header';
import { orderBy } from 'lodash-es/collection';
import { template } from 'lodash-es/string';
import i18n from '@giswebgroup/ki-wcp-base/src/decorators/i18n';
import query from '@giswebgroup/ki-wcp-base/src/decorators/query';
import computed from '@giswebgroup/ki-wcp-base/src/decorators/computed';
import nls from '../../locales/index.nls';

export default
@i18n(nls)
class KiStationNavList extends LitElement {
  // language=CSS
  static styles = css`
    :host {
      height: 100%;
      display: block;
    }

    vaadin-accordion {
      height: 100%;
    }

    vaadin-accordion vaadin-accordion-panel {
      max-height: calc(100% - 40px);
      display: flex;
      flex-direction: column;
    }
    vaadin-accordion-panel::part(toggle) {
      display: none;
    }

    vaadin-accordion-panel::part(summary) {
      padding: 0;
    }
    vaadin-accordion-panel::part(summary-content) {
      width: 100%;
    }

    vaadin-accordion-panel::part(content) {
      flex: 1;
    }
    vaadin-accordion-panel[opened]::part(content) {
      display: block;
      overflow: auto;
    }
  `;

  @query('#accordion')
  __accordionEl;

  static get properties() {
    return {
      stations: { type: Array },
      label: { type: String },
      favouriteStations: { type: Array },
      selectedTs: { type: Array },
      stationLabelTemplate: { type: String },
      stationLabelFormats: { type: Array },

      __allStations: { type: Array }, // inner use
      __favStations: { type: Array }, // inner use
    };
  }

  @computed(['stationLabelTemplate', 'stations'])
  get __allStations() {
    const stationList = this.stations.map(station => {
      return { ...station, label: this._getStationLabel(station), value: `${station.site_no}/${station.station_no}` };
    });

    return orderBy(stationList, 'label');
  }

  @computed(['stationLabelTemplate', 'favouriteStations'])
  get __favStations() {
    const stationList = this.favouriteStations.map(station => {
      return { ...station, label: this._getStationLabel(station), value: `${station.site_no}/${station.station_no}` };
    });

    return orderBy(stationList, 'label');
  }

  render() {
    // language=html
    return html`<vaadin-accordion id="accordion" @opened-changed="${this._switchStatus}" opened="1">
      <vaadin-accordion-panel>
        <div slot="summary">
          <ki-station-list-header
            .stationLabelFormats="${this.stationLabelFormats}"
            icon="ki ki-star"
            label="${this.i18n.t('favourites')}"
            .expand="${this.__accordionEl?.opened === 0}"
            hideFormatter
          ></ki-station-list-header>
        </div>
        <ki-station-list class="show" id="favourites" .data="${this.__favStations}" .selectedTs="${this.selectedTs}"></ki-station-list>
      </vaadin-accordion-panel>
      <vaadin-accordion-panel>
        <div slot="summary">
          <ki-station-list-header
            .stationLabelFormats="${this.stationLabelFormats}"
            stationLabelTemplate="${this.stationLabelTemplate}"
            icon="ki ki-map-marker"
            label="${this.i18n.t('stations')}"
            .expand="${this.__accordionEl?.opened === 1}"
            @updateFormat="${this._updateFormatter}"
          ></ki-station-list-header>
        </div>
        <ki-station-list id="stations" .selectedTs="${this.selectedTs}" .data="${this.__allStations}"></ki-station-list>
      </vaadin-accordion-panel>
    </vaadin-accordion>`;
  }

  _switchStatus() {
    this.requestUpdate();
  }

  _updateFormatter(event) {
    const { value } = event.detail;
    this.stationLabelTemplate = value;
  }

  _getStationLabel(station) {
    return template(this.stationLabelTemplate)({
      river_name: '',
      station_no: '',
      station_name: '',
      ...station,
    });
  }
}

customElements.define('ki-station-nav-list', KiStationNavList);
